<template>
    <div class="ArchiveChangeInfo">
        <div class="ArchiveChangeInfo_title">
            <div class="ArchiveChangeInfo_title_left">
                <span style="font-size: 14px;padding-left: 10px;margin-bottom: 10px;border-left: 3px solid var(--subjectColor);">变动信息</span>
            </div>
            <div class="ArchiveChangeInfo_title_right">
                <el-button v-if="canEdit" size="mini" @click="addArchiveChangeInfo">添加</el-button>
            </div>
        </div>
        <el-table :data="vo.passenger.changeInfo" border="1px" style="width: 100%" class="ArchiveChangeInfoList">
            <el-table-column type="index" label="序号" width="50" align="center" />
            <el-table-column prop="afterDept" label="现任部门" align="center">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="现任"> -->
                        <!-- <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark"> -->
                        <!-- :root-org-code="vo.orgCode" -->
                        <!-- <el-input v-model="scope.row.afterDept" v-select-dialog="'suborg'" org-level="2" dialog-title="选择现任部门" multiple="false" :index="scope.$index" placeholder="请选择现任部门" name="afterDept" /> -->

                        <el-input v-model="scope.row.afterDept" placeholder="请选择现任部门" class="input-with-select">
                            <el-button slot="append" icon="el-icon-more" @click="selectSuborg(scope.row,scope.$index,'选择现任部门','afterDept')"></el-button>
                        </el-input>
                        <!-- </el-tooltip> -->
                        <!-- </ValidationProvider> -->
                    </div>
                    <div v-else>{{ scope.row.afterDept }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="afterPost" label="现任职务" align="center" width="140px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="职务"> -->
                        <!-- <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark"> -->
                        <el-input v-model="scope.row.afterPost" v-can-edit v-listpage-dialog :can-edit="canEdit" listviewurl="rsgl.config.list_select?urlsearch=status:1" dialog-title="选择职务" :multiple="false" :index="scope.$index" placeholder="请选择职务" name="afterPost" exclude-fields="status,blankPlace" retain-btns="addObject" />
                        <!-- </el-tooltip> -->
                        <!-- </ValidationProvider> -->
                    </div>
                    <div v-else>{{ scope.row.afterPost }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="afterPostRank" label="现任职级" align="center" width="140px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="职级" :rules="postRankRules"> -->
                        <!-- <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark"> -->
                        <el-input v-model="scope.row.afterPostRank" v-can-edit v-listpage-dialog :can-edit="canEdit" listviewurl="rsgl.config.list_zj?urlsearch=status:1" dialog-title="选择职级" :multiple="false" :index="scope.$index" placeholder="请选择职级" name="afterPostRank" exclude-fields="status,blankPlace" retain-btns="addObject" />
                        <!-- </el-tooltip> -->
                        <!-- </ValidationProvider> -->
                    </div>
                    <div v-else>{{ scope.row.afterPostRank }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="beforeDept" label="原部门" align="center">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="现任"> -->
                        <!-- <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark"> -->
                        <!-- :root-org-code="vo.orgCode" -->
                        <!-- <el-input v-model="scope.row.beforeDept" v-select-dialog="'suborg'" org-level="2" dialog-title="选择原部门" multiple="false" :index="scope.$index" placeholder="请选择原部门" name="beforeDept" /> -->

                        <el-input v-model="scope.row.beforeDept" placeholder="请选择原部门" class="input-with-select">
                            <el-button slot="append" icon="el-icon-more" @click="selectSuborg(scope.row,scope.$index,'选择原部门','beforeDept')"></el-button>
                        </el-input>
                        <!-- </el-tooltip> -->
                        <!-- </ValidationProvider> -->
                    </div>
                    <div v-else>{{ scope.row.beforeDept }}</div>
                </template>
            </el-table-column>

            <el-table-column prop="beforePost" label="原职务" align="center" width="140px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="职务"> -->
                        <!-- <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark"> -->
                        <el-input v-model="scope.row.beforePost" v-can-edit v-listpage-dialog :can-edit="canEdit" listviewurl="rsgl.config.list_select?urlsearch=status:1" dialog-title="选择职务" :multiple="false" :index="scope.$index" placeholder="请选择职务" name="beforePost" exclude-fields="status,blankPlace" retain-btns="addObject" />
                        <!-- </el-tooltip> -->
                        <!-- </ValidationProvider> -->
                    </div>
                    <div v-else>{{ scope.row.beforePost }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="beforePostRank" label="原职级" align="center" width="140px">
                <template slot-scope="scope">
                    <div v-if="canEdit">
                        <!-- <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="职务" :rules="postRankRules"> -->
                        <!-- <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark"> -->
                        <el-input v-model="scope.row.beforePostRank" v-can-edit v-listpage-dialog :can-edit="canEdit" listviewurl="rsgl.config.list_zj?urlsearch=status:1" dialog-title="选择职级" :multiple="false" :index="scope.$index" placeholder="请选择职级" name="beforePostRank" exclude-fields="status,blankPlace" retain-btns="addObject" />
                        <!-- </el-tooltip> -->
                        <!-- </ValidationProvider> -->
                    </div>
                    <div v-else>{{ scope.row.beforePostRank }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="entryDate" label="报到日期" align="center" width="140px">
                <template slot-scope="scope">
                    <form-item
                        ref="entryDate"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: null, elementCssWidth: null, elementFormatter: '', elementReadonly: 1, elementType: 'date', emptyMessage: '', errorMessage: null, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '报到日期', propName: 'entryDate', propType: 'java.util.Date', textFormatter: 'yyyy年MM月dd日', valueMaxLength: null, valueMinLength: null, tbFieldName: 'entrydate', iconName: 'rqxzk', model: 'scope.row.entryDate', option: [], formTdAlign: 'text-left', weekday: 0 }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="issuingUnit" label="变动性质" align="center" width="140px">
                <template slot-scope="scope">
                    <form-item
                        ref="changeNature"
                        :field="{
                            defaultValue: null,
                            elementCanEdit: '{${canEdit}}',
                            elementCssHeight: null,
                            elementCssWidth: null,
                            elementFormatter: '转岗：转岗\n晋升：晋升\n轮岗：轮岗',
                            elementReadonly: 1,
                            elementType: 'select',
                            emptyMessage: '请选择变动性质',
                            errorMessage: null,
                            formTdAlign: 'text-left',
                            formTdColspan: 0,
                            isRequired: 0,
                            onClickEvent: null,
                            passenger: {},
                            propComment: '变动性质',
                            propName: 'changeNature',
                            propType: 'String',
                            textFormatter: null,
                            valueMaxLength: null,
                            valueMinLength: null,
                            model: 'scope.row.changeNature',
                            option: [
                                { value: '转岗', name: '转岗' },
                                { name: '晋升', value: '晋升' },
                                { name: '轮岗', value: '轮岗' }
                            ],
                            optionGenerateType: 0,
                            clearable: true,
                            filterable: false,
                            allowCreate: false,
                            readonlyShowChecked: 0
                        }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit" label="变动原因" align="center">
                <template slot-scope="scope">
                    <form-item
                        ref="chnageReason"
                        :field="{ defaultValue: null, elementCanEdit: '{${canEdit}}', elementCssHeight: 70, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入变动原因', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 0, onClickEvent: null, passenger: {}, propComment: '变动原因', propName: 'chnageReason', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'scope.row.chnageReason', option: [], autosize: false }"
                        :vo="scope.row"
                        :can-edit="canEdit"
                    />
                </template>
            </el-table-column>
            <el-table-column v-if="canEdit" label="操作" align="center" width="70px">
                <template slot-scope="scope">
                    <el-link type="primary" @click="delClick(scope.row)">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <RsglSelectTreeDialo />
    </div>
</template>

<script>
import RsglSelectTreeDialo from './SelectTreeDialog'
const moment = require('moment')
export default {
    name: 'ArchiveChangeInfo',
    components: {
        RsglSelectTreeDialo
    },
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 1 },
        isMypersonalRecords: { type: Boolean, default: false },
        moduleInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    setup() {
        const feeTypeRules = {
            required: true
        }
        return {
            feeTypeRules
        }
    },
    data() {
        return {
            // 通用变量
            loginUser: this.$store.getters.loginUser,
            uploadRow: {},
            uploadAttachList: [] // 当前待上传附件列表
        }
    },
    computed: {},
    watch: {},
    created() {},
    beforeDestroy() {},
    mounted() {},
    updated() {},
    methods: {
        timeFormat(val) {
            return val ? moment(new Date(val)).format('YYYY年MM月DD日') : ''
        },
        addArchiveChangeInfo() {
            this.$http({
                method: 'POST',
                url: '/rsgl/changeInfo/addNew'
            }).then((res) => {
                console.log(res, 'res')
                if (res.code === 'success') {
                    this.vo.passenger.changeInfo.push(res.body.vo)
                }
            })
        },
        selectSuborg(row, index, dialogTitle, name) {
            this.selectRow = row
            const el = {
                dialogTitle,
                index,
                multiple: false,
                attrs: { 'dialog-title': '选择部门', 'root-org-code': this.loginUser.orgCode, 'org-level': '2,3,4', index, name},
                value: ''
            }
            const vnode = {
                context: this,
                data: {
                    model: { expression: 'selectDialog' },
                    attrs: {}
                }
            }

            this.$bus.emit('RsglOpenSelectDialog', el, { value: 'suborg' }, vnode)
        },
        // 删除当前行
        delClick(row) {
            // 找到要删除的项的索引
            this.vo.passenger.changeInfo = this.vo.passenger.changeInfo.filter((item) => item.id !== row.id)
        },
        // 选择部门
        onSelectSuborgCompleted: function (selectedRows, attr) {
            if (attr.name === 'afterDept') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'afterDept', selectedRows[0].name)
                // this.$set(this.vo.passenger.changeInfo[attr.index], 'orgFullId', selectedRows[0].orgFullId)
            } else if (attr.name === 'beforeDept') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'beforeDept', selectedRows[0].name)
                // this.$set(this.vo.passenger.changeInfo[attr.index], 'orgFullId', selectedRows[0].orgFullId)
            }
        },
        // 选择数据列表
        onSelectListpageRowCompleted: function (selectedRows, attr) {
            if (attr.name === 'beforePostRank') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'beforePostRank', selectedRows[0].rankName)
            } else if (attr.name === 'afterPostRank') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'afterPostRank', selectedRows[0].rankName)
            } else if (attr.name === 'beforePost') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'beforePost', selectedRows[0].postName)
            } else if (attr.name === 'afterPost') {
                this.$set(this.vo.passenger.changeInfo[attr.index], 'afterPost', selectedRows[0].postName)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.ArchiveChangeInfo_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // background: #f2f5fb;
    // border: 1px solid #e3e8ee;
    // padding: 4px 6px !important;
    padding: 4px 6px 4px 0 !important;
    font-size: 14px;
    color: #333;
}
</style>
